import useMartyContext from 'hooks/useMartyContext';
import primeLogoSrc from 'images/amazon-prime.svg';
import vipShippingSrc from 'images/vip-shipping.svg';
import { useFeaturePdpEnhancements } from 'hooks/unleash/useFeaturePdpEnhancements';
import { FEATURE_PDP_OOS_UX } from 'constants/features';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';

import css from 'styles/components/productdetail/twoDayShippingPerk.scss';

export default function TwoDayShippingPerk() {
  const { testId } = useMartyContext();

  const { isTreatmentPricingEnabled } = useFeaturePdpEnhancements();
  const { isEnrolled: isPdpOosUx } = useIsEnrolledInVariant(FEATURE_PDP_OOS_UX);

  if (isTreatmentPricingEnabled) {
    return (
      <div className="flex h-5 items-center justify-start" data-test-id={testId('shippingPerkBox')}>
        {isPdpOosUx && <img className="mr-2 h-4" src={vipShippingSrc} alt="Vip Shipping" />}
        <div className="flex w-full items-center">
          <strong className="mr-1">FREE</strong>upgraded shipping & returns with
          {/* margin top aligns the prime logo text with the text above */}
          <img className="h5 ml-1 mt-2 w-8" src="https://m.media-amazon.com/images/G/01/zappos/ui/prime-icon.svg" alt="Amazon Prime" />
        </div>
      </div>
    );
  }

  return (
    <div className={css.wrapper} data-test-id={testId('shippingPerkBox')}>
      <div className={css.message}>
        <strong>FREE</strong> upgraded shipping & returns with
      </div>
      <img className={css.image} src={primeLogoSrc} alt="Amazon Prime" />
    </div>
  );
}
